module.exports = __webpack_public_path__ + "media/images/placeholder_image-2899d07ce7f715d6910effffecc5d79d.png";